<template>
  <div>
    <loading v-show="load" fullscrean="true"/>
    <div class="container-sacola" v-if="!load">
      <div class="container-fluid px-0">
        <div class="row">
          <div class="col-md-8">
            <cliente-manual ref="clienteManual" class="mb-2 mb-md-0" v-show="boxCliente" :empresa="empresa" :sacola="dados" @atualizar="atualizarCliente"/>
            <div v-if="dados.cliente && dados.cliente.id_cliente" v-show="!boxCliente">
              <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <div class="font-weight-bold mb-0">{{ autoatendimento ? 'Cliente' : dados.cliente.nome_cliente }}</div>
                    <div class="small" v-if="dados.cliente.telefone">Telefone: {{ dados.cliente.telefone | phone }}</div>
                  </div>
                  <div v-if="!dados.id_pedido">
                    <button class="btn btn-primary btn-sm mr-1" @click="editarCliente" title="Editar Cliente" style="width: 32px" v-if="!autoatendimento"><i class="fa fa-pencil-alt"></i></button>
                    <button class="btn btn-dark btn-sm" @click="removerCliente" title="Remover cliente deste pedido" style="width: 32px"><i class="fa fa-trash-alt"></i></button>
                  </div>
                </div>
                <div v-if="autoatendimento">
                  <hr class="mb-2">
                  <label class="small mb-0">Nome do cliente</label>
                  <input type="text" class="form-control mr-2" id="nomeCliente" v-model="dados.cliente.nome_cliente" placeholder="Informe o nome do cliente" @keyup.enter="enviarPedido()" @blur="salvarSacola()">
                </div>
              </div>
              <hr>
              <div :class="{'border border-danger p-2 rounded-sm': validarTipoPedido}">
                <div class="alert alert-danger small mb-2" v-show="validarTipoPedido">* Selecione entre entregar ou retirar o pedido</div>
                <div id="tipoPedido" class="row no-gutters">
                  <div class="col-4 pr-1">
                    <a href="javascript:" class="card text-center pointer card-pedido" :class="dados.tipo_pedido == 1 ? 'bg-primary text-white' : 'text-dark'" @click="selecionarEntrega('1', true)">
                      <icon name="delivery" size="18"/>
                      <div class="mt-1 small">Entregar</div>
                    </a>
                  </div>
                  <div class="col-4 pr-1">
                    <a href="javascript:" class="card text-center pointer card-pedido" :class="dados.tipo_pedido == 2 ? 'bg-primary text-white' : 'text-dark'" @click="selecionarEntrega('2', true)">
                      <div v-if="dados.origin === '4'">
                        <icon name="pedido" size="18"/>
                        <div class="mt-1 small">Para levar</div>
                      </div>
                      <div v-else>
                        <icon name="address" size="18"/>
                        <div class="mt-1 small">Retirar</div>
                      </div>
                    </a>
                  </div>
                  <div class="col-4">
                    <a href="javascript:" class="card text-center pointer card-pedido" :class="dados.tipo_pedido == 3 ? 'bg-primary text-white' : 'text-dark'" @click="selecionarEntrega('3', true)">
                      <icon name="local" size="18"/>
                      <div class="mt-1 small">Consumir</div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="card p-3 mt-3" v-show="dados.tipo_pedido == 1">
                <div v-if="dados.cliente.enderecos">
                  <a href="javascript:" class="d-flex align-items-center list-enderecos" v-for="e in dados.cliente.enderecos" @click="selecionarEndereco(e)">
                    <div style="width: 32px">
                      <i style="font-size: 16px" :class="dados.id_endereco === e.id_endereco ? 'fa fa-check text-primary' : 'fa fa-circle text-light'"></i>
                    </div>
                    <div class="mr-2">
                      <div class="font-weight-bold">{{e.logradouro}}, {{e.numero}}</div>
                      <div class="small">{{e.bairro}}, {{e.nome_cidade}} - {{e.sigla_estado}} <span v-if="e.complemento">- {{e.complemento}}</span></div>
                      <div class="small" v-if="e.taxa_entrega"><b class="text-success" v-if="e.entrega_gratis === '1'">Grátis</b><b v-else>{{ e.taxa_entrega | valor }}</b> / {{ e.tempo_entrega | tempo }}<span v-if="e.distance > 1"> / {{ e.distance | kilometer }}</span></div>
                      <div v-if="usarGeolocalizacao && e.raio_empresa !== '1' && !e.lat_endereco" class="badge badge-warning">
                        <i class="fa fa-map-marker-alt"></i> Informe um local no mapa
                      </div>
                      <div class="badge text-white bg-secondary" v-else-if="e.raio_empresa !== '1'">
                        <i class="fa fa-exclamation-triangle"></i> Entrega indisponível
                      </div>
                    </div>
                    <div v-if="e.fg_ativo === '1' && !usarGeolocalizacao" class="text-center ml-auto text-nowrap" @click.stop="$swal('Este endereço foi cadastrado no app pelo cliente')">
                      <i class="fa fa-info-circle" title="Cadastrado pelo cliente"></i>
                    </div>
                    <div class="text-center ml-auto text-nowrap" v-else>
                      <a href="javascript:" @click.stop="alterarEndereco(e)" class="btn btn-primary btn-sm mr-1" title="Editar"><i class="fa fa-pencil-alt"></i></a>
                      <a href="javascript:" @click.stop="removerEndereco(e)" class="btn btn-dark btn-sm" title="Remover" v-if="!autoatendimento"><i class="fa fa-trash-alt"></i></a>
                    </div>
                  </a>
                  <p class="text-center mb-2" style="font-size: 0.9rem" v-if="!dados.cliente.enderecos.length">Nenhum endereço cadastrado</p>
                </div>
                <div class="text-center">
                  <a class="btn btn-dark px-4" href="javascript:" @click="novoEndereco()">
                    <i class="fa fa-plus mr-1"></i> Novo endereço
                  </a>
                </div>
              </div>
              <div class="card p-3 mt-3" v-if="dados.tipo_pedido == 3">
                <h6 class="font-weight-bold mb-0">Consumir no Local</h6>
                <hr class="mb-2">
                <div class="row" v-if="ondeEstou">
                  <div class="col-md-6">
                    <div class="form-group mb-2">
                      <label for="ondeEstou" class="font-weight-bold m-0 small">Onde o cliente está?</label>
                      <select id="ondeEstou" class="form-control" v-model="ondeEstou.tipo" @change="toggleLocal()">
                        <option value="Balcão">Balcão</option>
                        <option value="Mesa">Mesa</option>
                        <option value="Comanda">Comanda</option>
                        <option value="Drive-thru">Drive-thru</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-2" v-if="['Mesa','Comanda'].includes(ondeEstou.tipo)">
                      <label for="mesa" class="font-weight-bold m-0 small">Número da {{ ondeEstou.tipo === 'Mesa' ? 'Mesa' : 'Comanda' }}</label>
                      <input id="mesa" type="number" class="form-control" v-model="ondeEstou.nolocal" placeholder="Ex: 12" required>
                    </div>
                    <div class="form-group mb-2" v-if="ondeEstou.tipo === 'Drive-thru'">
                      <label for="driveThru" class="font-weight-bold m-0 small">Automóvel</label>
                      <input id="driveThru" type="text" class="form-control" v-model="ondeEstou.nolocal" maxlength="20" placeholder="Ex: Uno Mille Cinza (ABC-1234)">
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="card p-3 mb-3">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="font-weight-bold mb-0">Agendar pedido</div>
                  <div>
                    <button class="btn btn-primary btn-sm" @click="changeAgendamento" title="Adicionar pedido agendado" style="width: 32px" v-if="!pedido_agendado" ><i class="fa fa-plus"></i></button>
                    <button class="btn btn-dark btn-sm ml-1" @click="changeAgendamento" title="Remover pedido agendado" style="width: 32px" v-else><i class="fa fa-trash-alt"></i></button>
                  </div>
                </div>
                <div v-if="pedido_agendado">
                  <hr>
                  <div class="row">
                    <div class="col-6">
                      <input id="dataAgendamento" type="date" class="form-control" v-model="data_agendamento">
                    </div>
                    <div class="col-6">
                      <input id="horaAgendamento" type="time" class="form-control" v-model="hora_agendamento">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 d-md-block" :class="{'d-none': boxCliente}">
            <div class="mb-1">
              <label class="small mb-0 font-weight-bold">Observações do pedido</label>
              <textarea id="obsPedido" class="form-control" placeholder="Ex: Não precisa de talheres.." rows="2"
                        v-model="dados.obs_pedido" maxlength="512" style="resize: none"></textarea>
            </div>
            <div class="mb-1" v-show="dados.tipo_pedido == 1">
              <label class="mb-0 small">Taxa de Entrega</label>
              <div class="d-flex">
                <money v-model="valor_frete" class="form-control" @keyup.enter.native="toggleFrete" :disabled="dados.valor_frete > 0"/>
                <button class="btn ml-1 px-3" @click="toggleFrete" :class="dados.valor_frete > 0 ? 'btn-dark' : 'btn-primary'" :title="dados.valor_frete > 0 ? 'Remover taxa de entrega' : 'Adicionar taxa de entrega'">
                  <i class="fa fa-trash-alt" v-if="dados.valor_frete > 0"></i><i class="fa fa-plus" v-else></i>
                </button>
              </div>
            </div>
            <div class="mb-1">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <label class="small mb-0 font-weight-bold">Desconto (R$)</label>
                  <div class="d-flex">
                    <money v-model="valor_desconto" class="form-control" @keyup.enter.native="toggleDesconto" :disabled="dados.valor_desconto > 0"/>
                    <button class="btn ml-1 px-3" @click="toggleDesconto" :class="dados.valor_desconto > 0 ? 'btn-dark' : 'btn-primary'" :title="dados.valor_desconto > 0 ? 'Remover desconto' : 'Adicionar desconto'">
                      <i class="fa fa-trash-alt" v-if="dados.valor_desconto > 0"></i><i class="fa fa-plus" v-else></i>
                    </button>
                  </div>
                </div>
                <div class="col-md-6 pl-2">
                  <label class="small mb-0 font-weight-bold">Desconto (%)</label>
                  <div class="d-flex">
                    <the-mask :mask="['##%']" class="form-control" placeholder="%" v-model="percent" @keydown.native.enter.prevent="calcularDesconto" :disabled="dados.valor_desconto > 0"/>
                    <button class="btn ml-1 px-3" @click="calcularDesconto()" :class="dados.valor_desconto > 0 ? 'btn-dark' : 'btn-primary'" :title="dados.valor_desconto > 0 ? 'Remover desconto' : 'Adicionar desconto'">
                      <i class="fa fa-trash-alt" v-if="dados.valor_desconto > 0"></i><i class="fa fa-plus" v-else></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div v-if="!['4','8'].includes(dados.origin)">
              <div id="formaPagamentoContainer" class="card border p-3 mb-2">
                <div v-if="dados.pagamento && dados.id_pagamento">
                  <div class="d-flex align-items-center">
                    <div class="mr-1" v-if="dados.pagamento.img_pagamento">
                      <img :src="dados.pagamento.img_pagamento" alt="Imagem pagamento" class="mr-2" style="width: 24px">
                    </div>
                    <div>
                      <h6 class="font-weight-bold mb-0">{{dados.pagamento.nome_pagamento}}</h6>
                      <div style="line-height: 0.9rem">
                        <div class="small mt-1" v-if="dados.troco > 0">Trazer troco para: {{dados.troco | valor}}</div>
                      </div>
                    </div>
                    <div class="ml-auto">
                      <button class="btn btn-primary btn-sm" @click="alterarPagamento()"><i class="fa fa-pencil-alt"></i></button>
                    </div>
                  </div>
                  <div class="border-top mt-2 pt-1" v-if="dados.pagamento.id_pagamento !== '2'">
                    <a href="#" class="text-dark text-decoration-none" @click.prevent="togglePagamento()">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="pl-1 mb-0">Pedido já pago</h6>
                        <img class="switch" src="../../assets/icons/switch-on.svg" v-if="dados.pedido_pago === '1'"/>
                        <img class="switch" src="../../assets/icons/switch-off.svg" v-else/>
                      </div>
                    </a>
                  </div>
                </div>
                <div v-else>
                  <h6 class="font-weight-bold mb-3">Formas de pagamento</h6>
                  <a href="javascript:" class="btn btn-block btn-dark" @click="alterarPagamento()">
                    {{dados.id_pagamento ? 'Alterar Pagamento' : 'Escolher Pagamento'}}
                  </a>
                </div>
              </div>
            </div>
            <div class="card mb-3 bg-white">
              <div class="p-3">
                <p class="mb-0 small">
                  <span class="float-right">{{dados.total - parseFloat(dados.valor_frete || '0') - parseFloat(valor_taxa) + parseFloat(dados.valor_desconto || '0') | valor}}</span>
                  Subtotal
                </p>
                <div>
                  <p class="mb-0 small" v-if="dados.valor_desconto > 0">
                    <span class="float-right">(-) {{dados.valor_desconto | valor}}</span>
                    Desconto
                  </p>
                  <p class="mb-0 small" v-show="dados.tipo_pedido == 1">
                    <span class="float-right" v-if="dados.valor_frete > 0">(+) {{dados.valor_frete | valor}}</span>
                    <span class="float-right text-success font-weight-bold" v-else>Grátis</span>
                    Entrega
                  </p>
                  <p class="mb-0 small" v-if="valor_taxa > 0 || valor_taxa < 0">
                    <span class="float-right" v-if="valor_taxa > 0">(+) {{valor_taxa | valor}}</span>
                    <span class="float-right" v-if="valor_taxa < 0">(-) {{valor_taxa * (-1) | valor}}</span>
                    Taxas
                  </p>
                  <p class="mb-0" v-if="dados.total > 0">
                    <b class="float-right">{{dados.total | valor}}</b>
                    Total
                  </p>
                </div>
              </div>
            </div>
            <div class="text-center mb-2">
              <button class="btn btn-outline-secondary btn-block" @click="$emit('voltar')"><i class="fa fa-plus mr-1"></i> Adicionar itens</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-pdv" :class="{'show': modalEndereco}">
      <div v-if="modalEndereco" class="modal-pdv-content p-0">
        <div class="container-fluid px-0">
          <div class="height-100">
            <div v-if="step > 0">
              <map-pedido ref="map" :dados="empresa" v-show="ajustarLocal" @editarDados="retornoMapa"/>
            </div>
            <loading v-if="loadEndereco"/>
            <div class="p-3" v-if="dados.cliente && dados.cliente.id_cliente" v-show="!loadEndereco && !ajustarLocal">
              <div v-if="step === 1" class="mb-4">
                <div v-if="menu === 1">
                  <via-cep-search :empresa="empresa" @buscarMapa="buscarMapa" @selPlace="selPlace"/>
                </div>
                <div v-if="menu === 2">
                  <map-search :empresa="empresa" @buscarMapa="buscarMapa" @selPlace="selPlace"/>
                </div>
              </div>

              <div v-show="step === 2">
                <form @submit.prevent="validarEndereco()">
                  <div class="row">
                    <div class="col-md-12">
                      <div v-if="!editarLogradouro" class="mb-2">
                        <h6 class="font-weight-bold mb-0">{{endereco.logradouro}}</h6>
                        <div>{{endereco.nome_cidade}} - {{endereco.sigla_estado}}</div>
                      </div>
                      <div v-else class="form-group mb-2">
                        <label class="mb-0" for="endereco">Rua*</label>
                        <input id="endereco" v-model="endereco.logradouro" class="form-control" maxlength="256" placeholder="Ex: Rua Joaquim de Oliveira" required type="text">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-2">
                        <label class="mb-0" for="numero">Número*</label>
                        <input id="numero" v-model="endereco.numero" class="form-control" maxlength="11" placeholder="Ex: 1170" required type="tel">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-2">
                        <label class="mb-0" for="bairro">Bairro*</label>
                        <input id="bairro" v-model="endereco.bairro" class="form-control" maxlength="45" placeholder="Ex: Centro" required type="text">
                      </div>
                    </div>
                    <div v-if="usarZonaEntrega" class="col-md-12">
                      <label class="mb-0 small"><i class="fa fa-map-marker-alt text-warning"></i> Taxa de Entrega *</label>
                      <div class="d-flex mb-2">
                        <modal-select class="w-100" :options="empresa.zonas" :value="endereco.id_zona" id="zonaEntrega" placeholder="Buscar taxas de entrega" @selected="selecionarZona"/>
                        <button class="btn btn-outline-dark ml-1" type="button" style="width: 70px" @click="selecionarZona(null)" title="Remover Taxa de Entrega'">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <div v-if="editarLogradouro && !limitarCidade" class="col-md-6">
                      <div class="form-group mb-2">
                        <label class="mb-0" for="bairro">Cidade*</label>
                        <input id="cidade" v-model="endereco.nome_cidade" class="form-control" maxlength="255" placeholder="Ex: Centro" required type="text">
                      </div>
                    </div>
                    <div v-if="editarLogradouro && !limitarCidade" class="col-md-6">
                      <div class="form-group mb-2">
                        <label class="mb-0" for="bairro">Estado</label>
                        <select id="estado" v-model="endereco.sigla_estado" class="form-control" required>
                          <option value="">Selecione um estado</option>
                          <option value="AC">AC</option>
                          <option value="AL">AL</option>
                          <option value="AP">AP</option>
                          <option value="AM">AM</option>
                          <option value="BA">BA</option>
                          <option value="CE">CE</option>
                          <option value="DF">DF</option>
                          <option value="ES">ES</option>
                          <option value="GO">GO</option>
                          <option value="MA">MA</option>
                          <option value="MT">MT</option>
                          <option value="MS">MS</option>
                          <option value="MG">MG</option>
                          <option value="PA">PA</option>
                          <option value="PB">PB</option>
                          <option value="PR">PR</option>
                          <option value="PE">PE</option>
                          <option value="PI">PI</option>
                          <option value="RJ">RJ</option>
                          <option value="RN">RN</option>
                          <option value="RS">RS</option>
                          <option value="RO">RO</option>
                          <option value="RR">RR</option>
                          <option value="SC">SC</option>
                          <option value="SP">SP</option>
                          <option value="SE">SE</option>
                          <option value="TO">TO</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mb-3">
                    <label class="mb-0" for="complemento">Referência <span class="pl-1 text-muted small">({{endereco.complemento ? endereco.complemento.length : 0}} de 100)</span></label>
                    <textarea id="complemento" v-model="endereco.complemento" class="form-control" maxlength="100" placeholder="Ex: Ponto de Referência (Casa amarela, portão preto..) / Complemento / Bloco / Apto" style="resize: none"></textarea>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light p-2 border-top d-flex justify-content-between">
          <a href="javascript:" @click="voltarEndereco()" class="btn btn-outline-dark py-2 px-4">Voltar</a>
          <button class="btn btn-success py-2 px-4 ml-auto" @click="validarEndereco()" v-show="step === 2 || ajustarLocal" :disabled="loadEndereco">
            {{ ajustarLocal ? 'Confirmar' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "@/components/gestor/loading";
  import Icon from "@/components/pedido-manual/IconPdv";
  import RevisePedido from "@/components/pedido-manual/RevisePedido";
  import ModalSelect from "@/components/commons/ModalSelect";
  import ClienteManual from "@/components/pedido-manual/ClienteManual";
  import ModalMenu from "@/components/commons/ModalMenu";
  import MapPedido from "@/components/pedido-manual/MapPedido";
  import MapSearch from "@/components/pedido-manual/endereco/MapSearch";
  import ViaCepSearch from "@/components/pedido-manual/endereco/ViaCepSearch";

  export default {
    name: 'Finalizar',
    components: {ViaCepSearch, MapSearch, MapPedido, ModalMenu, ClienteManual, ModalSelect, RevisePedido, Icon, Loading},
    props: ['empresa'],
    data() {
      return {
        token: localStorage.getItem('key'),
        dados: {},
        load: false,
        validarTipoPedido: false,
        valor_frete: 0,
        valor_desconto: 0,
        valor_taxa: 0,
        pedido_agendado: false,
        data_agendamento: false,
        hora_agendamento: false,
        troco: false,
        endereco: {},
        autoatendimento: false,
        frete_default: 0,
        ondeEstou: null,
        boxCliente: false,
        percent: '',

        editarLogradouro: false,
        loadEndereco: false,
        modalEndereco: false,
        ajustarLocal: false,
        places: [],
        step: 0,
        menu: 1,
        menus: [
          { nome: 'CEP', active: true },
          { nome: 'Endereço', active: true }
        ]
      }
    },

    methods: {
      selecionarEntrega(tipo) {
        this.validarTipoPedido = false;
        this.dados.tipo_pedido = tipo;
        this.dados.nolocal = '';
        this.dados.cliente.ultima_entrega = tipo;
        this.ondeEstou = (tipo == 3) ? { tipo: 'Balcão', nolocal: '' } : null

        if (tipo == 1) {
          this.dados.valor_frete = parseFloat(this.valor_frete);

          if (!this.dados.cliente.enderecos || !this.dados.cliente.enderecos.length) {
            this.novoEndereco();

          } else {
            this.selecionarEndereco(this.dados.cliente.enderecos[0]);
          }

        } else {
          this.dados.valor_frete = 0;
        }

        this.totalizar();
        this.salvarSacola();
      },

      salvarSacola() {
        this.$emit('salvarSacola', this.dados)
      },

      validarFinalizar() {
        if (!this.dados.cliente || !this.dados.cliente.id_cliente) {
          this.$swal({
            text: "Continuar sem o cadastro do cliente?",
            buttons: ['Não', 'Sim']
          }).then((res) => {
            if (res) {
              this.$refs.clienteManual.getClienteAtendimento();
            }
          });

          return true;
        }

        if (this.boxCliente) {
          return "Atenção, salve ou cancele a alteração do cliente";
        }

        if (!this.dados.tipo_pedido) {
          const elTipo = document.getElementById("tipoPedido")
          window.scrollTo({
            top: elTipo ? (elTipo.offsetTop - 150) : 0,
            left: 0,
            behavior: 'smooth'
          });

          this.validarTipoPedido = true;
          return "Atenção, selecione se é para entregar ou retirar no local o pedido.";

        } else {
          this.validarTipoPedido = false;
        }

        if (this.autoatendimento) {
          if (!this.dados.cliente.nome_cliente.trim()) {
            this.$swal("Por favor informe o nome do cliente").then(() => {
              this.$helpers.focusElement('nomeCliente');
            });

            return true;
          }

          if (this.dados.tipo_pedido == 1 && !this.dados.cliente.logradouro) {
            this.$swal("Por favor informe um endereço para entrega").then(() => {
              this.novoEndereco();
            });

            return true;
          }

        } else if (this.dados.tipo_pedido == 1) {
          if (!this.dados.id_endereco) {
            this.$swal("Por favor informe um endereço para entrega").then(() => {
              if (!this.dados.cliente.enderecos.length) {
                this.novoEndereco();
              }
            });

            return true;
          }

          if (this.usarGeolocalizacao && !this.dados.cliente.lat_endereco) {
            this.$swal("Por favor edite o endereço e informe um local no mapa");
            return true;
          }

          if (this.dados.cliente.raio_empresa !== '1') {
            this.$swal("O endereço selecionado não está disponível, altere ou informe um novo local.");
            return true;
          }

          if (this.usarZonaEntrega && !this.dados.cliente.id_zona) {
            this.$swal('A taxa de entrega é obrigatória. Informe uma taxa para enviar este pedido.').then(() => {
              let endereco = this.dados.cliente.enderecos.find(e => e.id_endereco === this.dados.id_endereco);
              this.alterarEndereco(endereco, false, 'zonaEntrega');
            });

            return true;
          }

          if (!this.usarZonaEntrega) {
            this.dados.cliente.id_zona = null;
          }
        }

        if (this.dados.total < 0) {
          return "Atenção, confira os dados enviados, o valor do seu pedido não poder ser menor que R$0,00";
        }

        if (this.dados.origin !== '4') {
          if (!this.dados.id_pagamento) {
            this.alterarPagamento(false, true);
            return true;
          }

          if (this.dados.id_pagamento === '1' && !this.troco && (!this.dados.troco || this.dados.troco < this.dados.total)) {
            this.alterarPagamento(true, true);
            return true;
          }
        }

        if (this.pedido_agendado) {
          if (!this.data_agendamento || !this.hora_agendamento) {
            this.$swal('Por favor informe uma data e hora para o agendamento do pedido.').then(() => {
              this.$helpers.focusElement('dataAgendamento');
            });

            return true;
          }

          this.dados.data_agendamento = `${this.data_agendamento}T${this.hora_agendamento}`

        } else if (this.dados.data_agendamento) {
          this.dados.data_agendamento = null;
        }

        if (this.dados.tipo_pedido == 3 && this.ondeEstou) {
          if (this.ondeEstou.tipo !== 'Balcão' && !this.ondeEstou.nolocal) {
            this.$swal(`Por favor informe os dados do local.`).then(() => {
              this.$helpers.focusElement(this.ondeEstou.tipo === 'Drive-thru' ? 'driveThru' : 'mesa');
            });

            return true;
          }

          this.dados.nolocal = this.ondeEstou.tipo + (this.ondeEstou.tipo !== 'Balcão' ? ` ${this.ondeEstou.nolocal}` : "");
        }

        return false;
      },

      enviarPedido() {
        let msg = this.validarFinalizar();

        if (msg && typeof msg === 'string') {
          this.$swal(msg);

        } else if (!msg) {
          this.finalizar();
        }
      },

      finalizar() {
        if (this.autoatendimento && this.dados.tipo_pedido == 1) {
          this.selecionarEndereco(this.endereco, false, true);
        }

        this.dados.id_empresa = this.empresa.id_empresa;
        this.$store.state.load = "Enviando pedido..";
        this.dados.version = 'v2';

        if (this.usaNovaImpressao && Number(this.configImpressao.print_automatico || 0) === 1) {
          this.dados.solicitar_impressao = true;
        }

        this.$http.post('delivery/pedido/' + this.token, this.dados)
          .then(res => {
            if (res.data && res.data.success) {
              this.$helpers.registrarFalhaImpressaoPedido(this, res.data, res.data, this.dados.solicitar_impressao === true);
              this.dados = {};
              this.$emit('fechar', res.data.id_pedido, res.data);

            } else {
              this.$store.state.load = false;
            }

          }, res => {
            this.$store.state.load = false;
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
          });
      },

      totalizar() {
        let total = 0;

        this.dados.produtos.forEach(p => {
          total += (parseFloat(p.quantidade) * parseFloat(p.valor));
        });

        total += parseFloat(this.dados.valor_frete || '0');
        total -= parseFloat(this.dados.valor_desconto || '0');

        if (this.dados.origin !== '4') {
          this.valor_taxa = this.calcularTaxa(total);
          this.dados.valor_taxa = this.valor_taxa;
        }

        this.dados.total = total + this.valor_taxa;
      },

      calcularTaxa(total) {
        if (this.dados.pagamento && this.dados.pagamento.id_pagamento && this.dados.pagamento.tipo_desconto > 0) {
          if (this.dados.pagamento.tipo_desconto === '1' && this.dados.pagamento.minimo_desconto > total) {
            return 0;
          }

          return parseFloat((total * (this.dados.pagamento.valor_taxa / 100)).toFixed(2));
        }

        return 0;
      },

      removerEndereco(e) {
        this.$swal({
          text: "Deseja remover este endereço?",
          buttons: ["Cancelar", "Sim"]
        }).then(res => {
          if (res) {
            this.endereco = e;
            this.endereco.delete = true;
            this.$store.state.load = true;
            this.salvarEndereco();
          }
        })
      },

      validarEndereco(finalizar) {
        if (this.ajustarLocal) {
          this.$refs.map.confirmar();
          return;
        }

        if (this.usarZonaEntrega) {
          if (!this.endereco.id_zona) {
            this.$swal('A taxa de entrega é obrigatória. Informe uma taxa para salvar este endereço.').then(() => {
              this.$helpers.focusElement('zonaEntrega');
            });

            return;
          }

          if (!this.endereco.bairro) {
            this.endereco.bairro = (this.empresa.zonas.find(z => z.id_zona === this.endereco.id_zona) || {}).nome_zona || '';
          }
        }

        if (!this.endereco.nome_cidade) {
          this.$swal('Por favor informe o nome da cidade').then(() => {
            this.$helpers.focusElement('cidade');
          });

          return;
        }

        if (!this.endereco.logradouro || !this.endereco.logradouro.trim() || !this.endereco.numero || !this.endereco.numero.trim()
            || !this.endereco.bairro || !this.endereco.bairro.trim()) {
          this.$swal("Por favor informe um endereço completo para entrega").then(() => {
            this.$helpers.focusElement('bairro');
          });

          return;
        }

        if (this.autoatendimento) {
          this.modalEndereco = false;

          if (this.usarZonaEntrega) {
            const zona = this.endereco.id_zona ? this.empresa.zonas.find(z => z.id_zona === this.endereco.id_zona) : null;

            if (zona) {
              this.endereco.taxa_entrega = parseFloat(zona.taxa_entrega);
              this.endereco.tempo_entrega = zona.tempo_entrega;
            }
          }

          this.dados.cliente.enderecos = [this.endereco];
          this.selecionarEndereco(this.endereco);

        } else if (this.usarGeolocalizacao && !this.endereco.buscar_mapa) {
          this.buscarGeocoding(1);

        } else {
          this.salvarEndereco(finalizar);
        }
      },

      salvarEndereco(finalizar) {
        this.loadEndereco = true;
        this.endereco.id_cliente = this.dados.cliente.id_cliente;
        this.endereco.id_empresa = this.empresa.id_empresa;

        this.$http.post(`endereco/${this.token}`, this.endereco).then(res => {
          this.loadEndereco = false;
          this.$store.state.load = false;

          if (res.data && res.data.success && res.data.dados) {
            this.modalEndereco = false;
            this.dados.id_endereco = res.data.id_endereco;
            this.dados.cliente = res.data.dados;

            this.$nextTick(() => {
              if (this.dados.cliente.enderecos && this.dados.cliente.enderecos.length) {
                const id_endereco = res.data.id_endereco;
                let endereco = this.dados.cliente.enderecos.find(e => e.id_endereco == id_endereco);

                if (endereco) {
                  this.selecionarEndereco(endereco, finalizar);

                } else {
                  this.selecionarEndereco(this.dados.cliente.enderecos[0], finalizar);
                }
              }
            })
          }

        }, res => {
          this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          this.loadEndereco = false;
          this.$store.state.load = false;
        });
      },

      selecionarEndereco(e, finalizar, manterTaxa) {
        if (e.raio_empresa !== '1') {
          this.dados.id_endereco = null;
          const alterarMapa = !e.lat_endereco && this.usarGeolocalizacao;
          this.$swal(alterarMapa ? "Por favor informe o local no mapa" : "O endereço não está disponível para entrega, altere ou cadastre um novo.").then(() => {
            if (alterarMapa) {
              this.alterarEndereco(e);
              this.buscarGeocoding(1);
            }
          });

          return;
        }

        this.dados.id_endereco = e.id_endereco || null;
        this.dados.cliente.id_endereco = e.id_endereco || null;
        this.dados.cliente.logradouro = e.logradouro || '';
        this.dados.cliente.bairro = e.bairro || '';
        this.dados.cliente.numero = e.numero || '';
        this.dados.cliente.complemento = e.complemento || '';
        this.dados.cliente.nome_cidade = e.nome_cidade || '';
        this.dados.cliente.sigla_estado = e.sigla_estado || '';
        this.dados.cliente.cep = e.cep || '';
        this.dados.cliente.long_endereco = e.long_endereco || null;
        this.dados.cliente.lat_endereco = e.lat_endereco || null;
        this.dados.cliente.id_cidade = e.id_cidade || null;
        this.dados.cliente.id_zona = e.id_zona || null;
        this.dados.cliente.distance = e.distance || null;
        this.dados.cliente.raio_empresa = e.raio_empresa;

        if (!manterTaxa) {
          let entrega_gratis = e.entrega_gratis === '1';
          this.valor_frete = !entrega_gratis ? parseFloat(e.taxa_entrega || this.frete_default) : 0;
          this.dados.valor_frete = this.valor_frete;
          this.totalizar();
        }

        this.salvarSacola();

        if (finalizar) {
          this.enviarPedido();
        }
      },

      voltarEndereco() {
        if (this.ajustarLocal) {
          this.ajustarLocal = false;
          return;
        }

        this.modalEndereco = false;
      },

      clearEndereco() {
        this.ajustarLocal = false;
        this.editarLogradouro = false;
        this.step = 1;
        this.menu = 1;
        this.endereco = {
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cep: this.cepUnico ? this.empresa.cep : '',
          id_cidade: this.limitarCidade ? this.empresa.id_cidade : null,
          nome_cidade: this.empresa.nome_cidade,
          sigla_estado: this.empresa.sigla_estado,
          lat_endereco: '',
          long_endereco: '',
          raio_empresa: '1',
          id_zona: null,
          tipo_endereco: !(this.dados.cliente?.enderecos || []).length ? '1' : '',
          selecionado: ''
        };
      },

      novoEndereco() {
        this.clearEndereco();

        if (this.usarGeolocalizacao || !this.cepUnico) {
          this.menu = this.usarGeolocalizacao ? 2 : 1;

        } else {
          this.step = 2;
          this.editarLogradouro = true;
        }

        this.modalEndereco = true;
        this.$nextTick(() => {
          if (this.step === 2) {
            this.$helpers.focusElement('endereco');

          } else {
            this.$helpers.focusElement(this.usarGeolocalizacao ? "logSearch" : "cepForm");
          }
        });
      },

      alterarEndereco(e, close, focus) {
        this.step = 2;
        this.ajustarLocal = false;
        this.editarLogradouro = false;
        this.endereco = JSON.parse(JSON.stringify(e));
        this.endereco.cep = this.endereco.cep_endereco || '';

        if (!close) {
          this.modalEndereco = true;
          this.$nextTick(() => {
            this.$helpers.focusElement(focus || 'numero');
          });
        }
      },

      buscarMapa() {
        const latitude  = this.empresa.lat_cidade;
        const longitude = this.empresa.long_cidade;

        if (!latitude || !longitude) {
          return;
        }

        this.endereco.lat_endereco = latitude;
        this.endereco.long_endereco = longitude;
        this.endereco.buscar_mapa = true;
        this.ajustarLocal = true;
        this.$refs.map.openMapa(this.endereco);
      },

      selPlace(p, manual) {
        this.step = 2;
        const logradouro = (p.logradouro || '').trim();
        this.editarLogradouro = !logradouro;

        if (manual) {
          this.$nextTick(() => {
            this.$helpers.focusElement('endereco');
          });

        } else {
          this.endereco.logradouro = logradouro;
          this.endereco.numero = (p.numero || '').trim();
          this.endereco.bairro = (p.bairro || '').trim();
          this.endereco.nome_cidade = p.nome_cidade || this.empresa.nome_cidade;
          this.endereco.sigla_estado = p.sigla_estado || this.empresa.sigla_estado;
          this.endereco.cep = p.cep || (this.cepUnico ? this.empresa.cep : '');
          this.$nextTick(() => {
            this.$helpers.focusElement(!logradouro ? 'endereco' : (this.endereco.numero ? 'bairro' : 'numero'));
          });

          if (this.endereco.bairro && this.usarZonaEntrega) {
            const bairro = this.empresa.zonas.find(z => z.nome_zona.toLowerCase() === this.endereco.bairro.toLowerCase());

            if (bairro) {
              this.endereco.id_zona = bairro.id_zona;
              this.valor_frete = parseFloat(bairro.taxa_entrega);
              this.dados.valor_frete = this.valor_frete;
              this.totalizar();
            }
          }
        }
      },

      retornoMapa(local) {
        this.ajustarLocal = false;
        this.editarLogradouro = false;
        this.endereco.lat_endereco = local.lat;
        this.endereco.long_endereco = local.lng;

        if (this.endereco.logradouro && this.endereco.numero && !this.endereco.buscar_mapa) {
          this.step = 0;
          this.salvarEndereco();

        } else {
          this.buscarGeocoding(2);
        }
      },

      buscarGeocoding(tipo) {
        let pesquisa = {
          logradouro: this.endereco.logradouro,
          numero: this.endereco.numero,
          nome_cidade: this.endereco.nome_cidade,
          sigla_estado: this.endereco.sigla_estado
        };

        if (tipo === 2) {
          pesquisa = {
            latitude: this.endereco.lat_endereco,
            longitude: this.endereco.long_endereco
          }
        }

        this.loadEndereco = true;

        this.$http.post(`${this.base_server}delivery/${this.empresa.token}/validar-endereco/`, pesquisa)
          .then(res => {
            this.loadEndereco = false;
            let dados = res.data;

            if (dados.success) {
              if (tipo === 2) {
                if (dados.results && dados.results.length) {
                  dados = dados.results;

                  const cep = dados.find(e => e.types.includes('postal_code'));
                  const logradouro = dados.find(e => e.types.includes('route'));
                  const bairro = dados.find(e => e.types.includes('sublocality'));
                  const nome_cidade = dados.find(e => e.types.includes('administrative_area_level_2'));
                  const sigla_estado = dados.find(e => e.types.includes('administrative_area_level_1'));

                  this.endereco.cep = cep ? cep.long_name.replace('-','') : '';
                  this.endereco.logradouro = logradouro?.long_name !== 'Unnamed Road' ? (logradouro?.long_name || '') : '';
                  this.endereco.bairro = bairro ? bairro.long_name : '';
                  this.endereco.nome_cidade = nome_cidade?.long_name || this.empresa.nome_cidade;
                  this.endereco.sigla_estado = sigla_estado?.short_name || this.empresa.sigla_estado;
                  this.step = 2;
                  this.$nextTick(() => {
                    this.$helpers.focusElement('numero');
                  });

                  return;
                }

                this.$swal("Não conseguimos processar seu endereço. Insira manualmente.")

              } else {
                this.endereco.buscar_mapa = false;
                this.endereco.lat_endereco = dados.lat;
                this.endereco.long_endereco = dados.lng;
                this.ajustarLocal = true;
                this.$refs.map.openMapa(this.endereco);
              }

            } else {
              const msg = (tipo === 2) ? "Por favor verifique o local no mapa informado" : "Por favor busque pelo nome da Rua/Avenida";
              this.$swal("Endereço não encontrado! " + msg + " e tente novamente.").then(() => {
                if (tipo === 1 && this.limitarCidade) {
                  this.step = 1;
                  this.menu = 2;
                  this.$nextTick(() => {
                    this.$helpers.focusElement(this.menu === 2 ? "logSearch" : "cepForm");
                  });
                }
              });
            }

          }, res => {
            this.loadEndereco = false;
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
          });
      },

      alterarPagamento(troco, finalizar) {
        this.$emit('openModalPagamento', troco, finalizar);
      },

      addPagamento(dados, finalizar) {
        this.dados.id_pagamento = dados.id_pagamento;
        this.dados.troco = dados.troco;
        this.dados.pedido_pago = '';
        this.dados.pagamento = this.empresa.pagamentos ? (this.empresa.pagamentos.find(p => p.id_pagamento === dados.id_pagamento) || null) : null;
        this.troco = true;
        this.totalizar();
        this.salvarSacola();

        if (finalizar) {
          this.enviarPedido();

        } else {
          this.$helpers.focusElement('finalizarPedido');
        }
      },

      togglePagamento() {
        if (this.dados.pedido_pago !== '1') {
          this.$swal({
            text: `Deseja marcar este pedido como pago?`,
            buttons: ["Cancelar", "Sim!"]
          }).then((result) => {
            if (result) {
              this.dados.pedido_pago = '1';
              this.salvarSacola();
            }
          });

        } else {
          this.dados.pedido_pago = '0';
          this.salvarSacola();
        }
      },

      changeAgendamento() {
        const date = new Date();
        this.pedido_agendado = !this.pedido_agendado;
        this.data_agendamento = this.pedido_agendado ? date.toDateInputValue() : null;
        this.hora_agendamento = this.pedido_agendado ? date.toTimeInputValue() : null;

        this.$nextTick(() => {
          if (this.pedido_agendado) {
            this.$helpers.focusElement('dataAgendamento');
          }
        });
      },

      toggleLocal() {
        this.$nextTick(() => {
          if (this.ondeEstou.tipo !== 'Balcão') {
            this.$helpers.focusElement(this.ondeEstou.tipo === 'Drive-thru' ? 'driveThru' : 'mesa');
          }
        });

        this.ondeEstou.nolocal = "";
      },

      toggleFrete() {
        if (this.dados.valor_frete > 0) {
          this.valor_frete = 0;
          this.dados.valor_frete = 0;

        } else {
          this.dados.valor_frete = this.valor_frete;
        }

        this.totalizar();
      },

      toggleDesconto() {
        if (this.dados.valor_desconto > 0) {
          this.percent = '';
          this.valor_desconto = 0;
          this.dados.valor_desconto = 0;
          this.totalizar();

        } else {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.dados.valor_desconto = this.valor_desconto;
            this.totalizar();
          });
        }
      },

      calcularDesconto() {
        if (this.dados.valor_desconto > 0) {
          this.toggleDesconto();

        } else if (this.percent > 0) {
          this.$helpers.confirmarSenhaAdm(this, () => {
            const desconto = parseFloat((this.dados.total * this.percent / 100).toFixed(2));
            this.valor_desconto = desconto;
            this.dados.valor_desconto = desconto;
            this.totalizar();
          });
        }
      },

      editarCliente() {
        this.boxCliente = true;
        this.$refs.clienteManual.editarCliente(this.dados.cliente);
      },

      removerCliente() {
        this.$swal({
          text: `Deseja remover este cliente deste pedido?`,
          buttons: ["Cancelar", "Sim!"]
        }).then((result) => {
          if (result) {
            this.dados.cliente = {};
            this.dados.valor_frete = 0;
            this.dados.tipo_pedido = '';
            this.boxCliente = true;
            this.salvarSacola();
            this.$nextTick(() => {
              this.$refs.clienteManual.focusPesquisa(true);
            });
          }
        });
      },

      selecionarZona(zona) {
        this.endereco.id_zona = zona ? zona.id_zona : null;
      },

      clearPedido() {
        this.valor_frete = 0;
        this.valor_taxa = 0;
        this.valor_desconto = 0;
        this.pedido_agendado = false;
        this.data_agendamento = null;
        this.hora_agendamento = null;
        this.ondeEstou = null;
      },

      atualizarCliente(cliente) {
        this.boxCliente = false;

        if (!cliente) {
          return;
        }

        this.dados.cliente = cliente || {};
        this.autoatendimento = this.dados.cliente && this.dados.cliente.tipo_cliente === '2';

        if (this.autoatendimento) {
          if (this.dados.id_pedido) {
            this.alterarEndereco(this.dados.cliente, true);

          } else if (!this.dados.id_pedido && !this.dados.tipo_pedido) {
            const frete = this.dados.valor_frete ? this.dados.valor_frete : this.frete_default;
            this.valor_frete = parseFloat(frete || '0');
            this.selecionarEntrega('2');
          }

          this.$nextTick(() => {
            this.$helpers.focusElement('nomeCliente', true);
          });

        } else if (!this.dados.tipo_pedido) {
          this.selecionarEntrega('2');

        } else if (this.dados.tipo_pedido == 1 && this.dados.cliente.enderecos && this.dados.cliente.enderecos.length) {
          const id_endereco = this.dados.id_endereco || this.dados.cliente.endereco_default;
          let endereco = id_endereco ? this.dados.cliente.enderecos.find(e => e.id_endereco === id_endereco) : null;

          if (!endereco) {
            endereco = this.dados.cliente.enderecos[0];
          }

          this.selecionarEndereco(endereco, false, true);
        }
      },

      openFinalizar(sacola, atualizar) {
        this.dados = sacola;
        this.boxCliente = (!this.dados.cliente || !this.dados.cliente.id_cliente);
        this.autoatendimento = this.dados.cliente && this.dados.cliente.tipo_cliente === '2';
        this.dados.valor_desconto = this.dados.valor_desconto ? parseFloat(this.dados.valor_desconto) : 0;
        this.valor_desconto = this.dados.valor_desconto;
        this.dados.id_endereco = this.autoatendimento ? null : (this.dados.id_endereco || null);

        if (atualizar) {
          this.frete_default = this.empresa.valor_frete || '0';

          if (this.dados.data_agendamento) {
            this.pedido_agendado = true;

            if (this.dados.data_agendamento.length > 16) {
              this.data_agendamento = this.dados.data_agendamento.substring(0,10);
              this.hora_agendamento = this.dados.data_agendamento.substring(11,16);
            }
          }

          if (this.dados.id_pedido) {
            const tipoLocal = this.dados.nolocal ? this.dados.nolocal.trim().split(' ')[0] : 'Balcão';
            this.ondeEstou = {
              tipo: tipoLocal.replace(':', ''),
              nolocal: (this.dados.nolocal || '').replace(tipoLocal, "").trim()
            };
          }
        }

        if (atualizar && this.dados.cliente && this.dados.cliente.id_cliente) {
          this.atualizarCliente(this.dados.cliente);

        } else if (this.boxCliente) {
          this.$refs.clienteManual.focusPesquisa(true);
        }

        this.totalizar();
      }
    },

    computed: {
      limitarCidade() {
        return this.empresa.limitar_cidade;
      },

      usarZonaEntrega() {
        return this.empresa.tipo_entrega === 2;
      },

      usarGeolocalizacao() {
        return this.empresa.tipo_entrega === 3 && !this.autoatendimento;
      },

      cepUnico() {
        return !!this.empresa.cep_cidade;
      },

      configImpressao() {
        return this.$store.state.configImpressao
      },

      usaNovaImpressao() {
        return Number(this.configImpressao.migrado_legado || 0) === 1;
      }
    },

    beforeDestroy() {
      this.modalEndereco = false;
    }
  }
</script>
<style scoped>
  .card-pedido {
    height: 65px;
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .card-pedido:hover {
    text-decoration: none;
  }

  .list-enderecos {
    text-decoration: none;
    color: var(--dark);
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #dee2e6;
  }

  @media (max-width: 767px) {
    .container-sacola {
      height: auto;
      overflow: visible;
    }
  }
</style>
